export const wiperx = {
    'images': [],
    'mainFeatures': [
        'Nano Graphite Coating with Premium Nature Rubber. ',
        'Triple Rotating Structure and Spoiler Exterior Design',
        'Invisible Leveraged Balancing Structure',
        'Patented Multi-functional Mounting Base & Adapters.',
        'Patented New Flexible Design',
    ],
    'material': [
        'Rubber: Premium Nature Rubber.',
        'Steel: SGCC, Electrostatic Powder Coating.',
        'Rivet: SUS302',
        'Plastic: Spacer & Adapter: POM, Spoiler: TPE',
        'Stainless Steel Backing: SUS304ES',
    ],
    'featureIcons': ["11", "02", "03", "04", "07", "10"],
    'otherFeatures': ["01", "02"],
    'specification': [
        { "inch": "11", "mm": "280", "claw": "6", "width": "6", "thickness": "0.8" },
        { "inch": "12", "mm": "300", "claw": "6", "width": "6", "thickness": "0.8" },
        { "inch": "13", "mm": "330", "claw": "6", "width": "6", "thickness": "0.8" },
        { "inch": "14", "mm": "350", "claw": "6", "width": "6", "thickness": "0.8" },
        { "inch": "15", "mm": "380", "claw": "6", "width": "6", "thickness": "0.8" },
        { "inch": "16", "mm": "400", "claw": "8", "width": "6", "thickness": "0.9" },
        { "inch": "17", "mm": "425", "claw": "8", "width": "6", "thickness": "0.9" },
        { "inch": "18", "mm": "450", "claw": "8", "width": "6", "thickness": "0.9" },
        { "inch": "19", "mm": "475", "claw": "8", "width": "6", "thickness": "0.9" },
        { "inch": "20", "mm": "500", "claw": "8", "width": "6", "thickness": "0.9" },
        { "inch": "21", "mm": "530", "claw": "8", "width": "6", "thickness": "0.9" },
        { "inch": "22", "mm": "560", "claw": "8", "width": "6", "thickness": "0.9" },
        { "inch": "24", "mm": "600", "claw": "8", "width": "8", "thickness": "0.9" },
        { "inch": "26", "mm": "650", "claw": "8", "width": "8", "thickness": "1" },
        { "inch": "28", "mm": "700", "claw": "8", "width": "8", "thickness": "1" }
    ],
    'adapters': [
        "b1", "b6", "bl-2a", "cl+cl-r", "m3", "m4", "m5", "ml", "ph-3", "pl", "pt-3", "pt6", "pt-r", "tl-2", "tl4a", "tlc", "a3"
    ]
}
